module.exports = __webpack_public_path__ + "logo.a961dfbf36f110092c3f";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles